import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Spinner from '../App/Components/Spinner/Spinner'
import { ICustomer } from '../Customer/interfaces/ICustomer'
import InvoiceData from '../Customer/InvoiceData/InvoiceData'
import Search from '../Customer/Search/Search'

import { createInvoice } from './client'
import style from './style.scss'
import { InvoiceTable } from './Table/InvoiceTable'
import { InvoiceLine } from './type'

type Props = {
  receiptId?: string
}

export const Invoice = (props: Props) => {
  const { t } = useTranslation()
  const [customer, setCustomer] = useState<ICustomer | null>(null)
  const [customerSaved, setCustomerSaved] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const receiptId =
    typeof props.receiptId !== 'undefined' ? props.receiptId : null

  const updateCustomer = (newCustomerData: ICustomer, isSaved: boolean) => {
    setCustomer(newCustomerData)
    setCustomerSaved(isSaved)
  }

  const saveInvoice = async (lines: InvoiceLine[]) => {
    setLoading(true)
    const response = await createInvoice(customer, lines, receiptId)
    window.location.href = `/register/invoice/open/${response}`
  }

  if (loading || (null === customer && null !== receiptId)) {
    return <Spinner />
  }

  if (null === customer) {
    return (
      <div className={style.pageLayout}>
        <h1>{t('New invoice')}</h1>
        <Search
          onSelected={newCustomerData => updateCustomer(newCustomerData, false)}
          onDeselected={() => updateCustomer(null, false)}
          withInvoiceInformation
        />
      </div>
    )
  }

  if (!customerSaved) {
    return (
      <div className={style.pageLayout}>
        <h1>{t('New invoice')}</h1>
        <div className={style.customer} onClick={() => setCustomer(null)}>
          <FontAwesomeIcon icon={faTrashAlt} className={style.deleteIcon} />
          {customer.fullName}
        </div>
        <InvoiceData
          customer={customer}
          onSubmit={(newCustomerData: ICustomer) =>
            updateCustomer(newCustomerData, true)
          }
        />
      </div>
    )
  }

  return (
    <div className={`${style.pageLayout} ${style.large}`}>
      <h1>{t('New invoice')}</h1>
      <div className={style.customer} onClick={() => setCustomer(null)}>
        <FontAwesomeIcon icon={faTrashAlt} className={style.deleteIcon} />
        {customer.fullName}
      </div>
      <InvoiceTable onSave={saveInvoice} />
    </div>
  )
}
